BX.addCustomEvent("DevBxWebFormCreated", function(app) {
    app.component('devbx-webform-mode-finish-page', {

        computed: {
            finishPage() {
                let page = false;

                this.$root.webForm.finishPageCond.every(pageCond => {

                    if (this.$root.checkCondition(pageCond, pageCond, 'showRule') === true)
                    {
                        page = pageCond;
                    }

                    return page === false;
                });

                if (!page)
                    page = this.$root.webForm.finishPage;

                return page;
            },
        },

        template: `
        <div class="devbx-webform-theme devbx-webform devbx-webform-finish-page"
            :class="$root.formClass">
            <div class="devbx-webform-container">
                <div class="devbx-webform-content">
                    <div class="devbx-webform-finish-page-content" v-html="finishPage.content">
                    </div>
                </div>
            </div>
        </div>
        `
    });
});